import gql from 'graphql-tag';

export default gql`
  mutation deletePantryReservation($input: DeletePantryReservationInput!) {
    deletePantryReservation(input: $input)
  }
`;
